// BackendPageForHP.js — the WorksForYou homepage.
//
// Reads its data from <ConfigContext>:
//   - config.PREFIX       → backend mount prefix (for logo etc.)
//   - homepageData        → { menu_bar, main_section, slogans (dict now —
//                              see slogans.json restructure), subsections }
//
// Description boxes live under subsections.subsection_0.boxes_content
// (list or dict shape both tolerated). Slogans + the end-of-page closer
// both come from homepageData.slogans (the file holds both blocks).

import React, { useContext } from 'react';
import { ConfigContext } from '../../App';
import {
  Navigation,
  HeroCarousel,
  DescriptionBoxes,
  SloganRotator,
  Subsections,
  EndOfPageMessage,
  Footer,
} from '../../myReactLib/MainBlocks';

function BackendPageForHP() {
  const { config, homepageData, contactData } = useContext(ConfigContext);
  if (!homepageData) return null;
  const { menu_bar, main_section, slogans, subsections } = homepageData;

  // --- Description boxes ---
  // Own homepage module now: homepageData.description_boxes = { boxes, layout }.
  // Legacy fallback: older backends attached them to subsections.subsection_0.boxes_content.
  const dbModule = homepageData.description_boxes;
  let descBoxesArray = [];
  let dbLayout = {};
  let dbBottomMargin;
  if (dbModule && dbModule.boxes) {
    descBoxesArray = Array.isArray(dbModule.boxes) ? dbModule.boxes : Object.values(dbModule.boxes);
    dbLayout = dbModule.layout || {};
    dbBottomMargin = dbLayout.bottom_margin;
  } else {
    const sub0 = (subsections && subsections.subsection_0) || {};
    const sub0BoxesRaw = sub0.boxes_content;
    descBoxesArray = Array.isArray(sub0BoxesRaw) ? sub0BoxesRaw : (sub0BoxesRaw ? Object.values(sub0BoxesRaw) : []);
    dbLayout = sub0.boxes_size ? { box_size: { desktop: sub0.boxes_size } } : {};
    dbBottomMargin = sub0.bottom_margin;
  }

  // --- Slogans + takeaway ---
  // slogans is a dict: slogan_1..N (each a resolved {text,format}) + takeaway_message.
  // Backwards-compatible with the old flat array shape too.
  let sloganLines = [];
  let takeawayBlock = null;
  if (Array.isArray(slogans)) {
    sloganLines = slogans;
  } else if (slogans && typeof slogans === 'object') {
    sloganLines = Object.entries(slogans)
      .filter(([k]) => k.startsWith('slogan_'))
      .sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true }))
      .map(([, v]) => v);
    takeawayBlock = slogans.takeaway_message || null;
  }

  return (
    <div className="w4u-page">
      <Navigation menuBar={menu_bar} prefix={config.PREFIX} />
      <main className="w4u-main">
        <HeroCarousel    mainSection={main_section} />
        <SloganRotator   slogans={sloganLines} rotation={slogans && slogans.rotation} />
        <DescriptionBoxes boxes={descBoxesArray} layout={dbLayout} bottomMargin={dbBottomMargin} />
        <Subsections     subsections={subsections} />
        <EndOfPageMessage takeaway={takeawayBlock} />
      </main>
      <Footer menuBar={menu_bar} config={config} contactData={contactData} footer={homepageData.footer} />
    </div>
  );
}

export default BackendPageForHP;
